import {
  ContentIndexTypeEnum,
  ContentTypeEnum,
  IStaticContext,
  IStaticData,
  ITableDataIndexType,
  TitleLevelEnum,
} from "../dataType";

const data: Array<IStaticData> = [
  {
    title: {
      text: "2つの認証方式について",
    },
    content: [
      {
        text: "当サイトでは、2つの認証方式（APIキー / OAuth2.0）のいずれかを選んでアプリケーションを作成することができます。利用可能なAPIの種類に違いはありません。",
      },
      {
        text: "APIキー認証とOAuth2.0認証には以下のような違いがあります。",
      },
      {
        type: ContentTypeEnum.table,
        table: {
          pcTable: {
            column: [
              {
                prop: "column1",
                label: "",
                width: "194",
              },
              {
                prop: "column2",
                label: "APIキー認証",
              },
              {
                prop: "column3",
                label: "OAuth2.0認証",
              },
            ],
            data: [
              {
                column1: [
                  {
                    text: "想定用途",
                  },
                ],
                column2: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "録画した映像データから定期的に静止画を取得できるようにしたい",
                  },
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "映像上で何かを検知した時の動画を取得できるようにしたい",
                  },
                ],
                column3: [
                  {
                    indexType: ITableDataIndexType.circle,
                    text: "独自のアプリケーションを開発して自社SaaSへ組み込みたい",
                  },
                ],
              },
              {
                column1: [
                  {
                    text: "こんな人におすすめ",
                  },
                ],
                column2: [
                  {
                    text: "最小限の実装でAPIを試してみたい方",
                  },
                  {
                    text: "自社SaaSを持たない方",
                  },
                  {
                    text: "連携デバイス管理はセーフィーに任せたい方",
                  },
                ],
                column3: [
                  {
                    text: "自社SaaSへ組み込みたい方",
                  },
                  {
                    text: "より強固なセキュリティで連携したい方",
                  },
                  {
                    text: "連携デバイス管理は自社システムで掌握したい方",
                  },
                ],
              },
              {
                column1: [
                  {
                    text: "デバイスオーナーの実施事項",
                  },
                ],
                column2: [
                  {
                    text: "アプリケーションの追加申請",
                  },
                ],
                column3: [
                  {
                    text: "ユーザー認証画面への認証情報の入力",
                  },
                ],
              },
              {
                column1: [
                  {
                    text: "アプリケーション利用の際に必要となる作業",
                  },
                ],
                column2: [
                  {
                    text: "APIキーの発行",
                  },
                  {
                    text: "アプリケーションの追加申請への承認",
                  },
                  {
                    text: "APIコール時のAPIキーの設定",
                  },
                ],
                column3: [
                  {
                    text: "Client ID/Secretの発行",
                  },
                  {
                    text: "ユーザー認証画面のURL作成・組込",
                  },
                  {
                    text: "認証完了後のRedirect URIの準備",
                  },
                  {
                    text: "アクセストークンのリフレッシュ",
                  },
                  {
                    text: "※更新頻度は、自社SaaSの特性に応じて設定してください。",
                  },
                  {
                    text: "APIコール時のアクセストークンの設定",
                  },
                ],
              },
            ],
          },
          spTable: [
            {
              column: [
                {
                  prop: "column1",
                  label: "",
                  width: "100",
                },
                {
                  prop: "column2",
                  label: "APIキー認証",
                },
              ],
              data: [
                {
                  column1: [
                    {
                      text: "想定される用途例",
                    },
                  ],
                  column2: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "録画した映像データから定期的に静止画を取得できるようにしたい",
                    },
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "映像上で何かを検知した時の動画を取得できるようにしたい",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "こんな方におすすめ",
                    },
                  ],
                  column2: [
                    {
                      text: "最小限の実装でAPIを試してみたい方",
                    },
                    {
                      text: "自社SaaSを持たない方",
                    },
                    {
                      text: "連携デバイス管理をセーフィーにまかせたい方",
                    },
                  ],
                  column3: [
                    {
                      text: "より強固なセキュリティで運用したい方",
                    },
                    {
                      text: "Safieと自社SaaSを連携させたい方",
                    },
                    {
                      text: "連携デバイス管理を自社システムで行いたい方",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "デバイスオーナーの実施事項",
                    },
                  ],
                  column2: [
                    {
                      text: "アプリケーションの追加申請",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "アプリケーション利用の際に必要となる作業",
                    },
                  ],
                  column2: [
                    {
                      text: "APIキーの発行",
                    },
                    {
                      text: "アプリケーションの追加申請への承認",
                    },
                    {
                      text: "APIコール時のAPIキーの設定",
                    },
                  ],
                },
              ],
            },
            {
              column: [
                {
                  prop: "column1",
                  label: "",
                  width: "100",
                },
                {
                  prop: "column3",
                  label: "OAuth2.0認証",
                },
              ],
              data: [
                {
                  column1: [
                    {
                      text: "想定される用途例",
                    },
                  ],
                  column3: [
                    {
                      indexType: ITableDataIndexType.circle,
                      text: "独自のアプリケーションを開発して自社SaaSへ組み込みたい",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "こんな方におすすめ",
                    },
                  ],
                  column3: [
                    {
                      text: "より強固なセキュリティで運用したい方",
                    },
                    {
                      text: "Safieと自社SaaSを連携させたい方",
                    },
                    {
                      text: "連携デバイス管理を自社システムで行いたい方",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "デバイスオーナーの実施事項",
                    },
                  ],
                  column3: [
                    {
                      text: "ユーザー認証画面への認証情報の入力",
                    },
                  ],
                },
                {
                  column1: [
                    {
                      text: "アプリケーション利用の際に必要となる作業",
                    },
                  ],
                  column3: [
                    {
                      text: "Client ID/Secretの発行",
                    },
                    {
                      text: "ユーザー認証画面のURL作成・組込",
                    },
                    {
                      text: "認証完了後のRedirect URIの準備",
                    },
                    {
                      text: "アクセストークンのリフレッシュ",
                    },
                    {
                      text: "※更新頻度は、自社SaaSの特性に応じて設定してください。",
                    },
                    {
                      text: "APIコール時のアクセストークンの設定",
                    },
                  ],
                },
              ],
            },
          ],
        },
      },
    ],
  },
  {
    title: {
      text: "デバイス一覧取得までの手順",
    },
  },
  {
    title: {
      level: TitleLevelEnum.second,
      text: "APIキー認証の場合",
      hasBorder: true,
    },
  },
  {
    title: {
      level: TitleLevelEnum.third,
      text: "APIキー認証の場合",
      titleIndex: "1.",
    },
    content: [
      {
        text: "<a class='is-static-link' href='/tutorial/api-key' target='_blank'>こちら</a>を参照してAPIキーを取得してください。",
        type: ContentTypeEnum.link,
      },
    ],
  },
  {
    title: {
      level: TitleLevelEnum.third,
      text: "デバイス一覧の取得",
      titleIndex: "2.",
    },
    content: [
      {
        text: "取得したAPIキーを使ってアクセス可能なデバイス一覧を取得します。デバイス一覧を取得するためのサンプルコードは<a class='is-static-link' href='https://github.com/SafieDev/safie-api-sample-code/tree/main/authorization-api-key' target='_blank'>こちら</a>をご参照ください。各種APIリクエストの際のクエリーパラメータとなるdevice_idの値は、取得したデバイス一覧でご確認ください。",
        type: ContentTypeEnum.link,
      },
    ],
  },
  {
    title: {
      level: TitleLevelEnum.second,
      text: "OAuth2.0認証",
      hasBorder: true,
    },
  },
  {
    title: {
      level: TitleLevelEnum.third,
      text: "OAuth2.0認証方式のアプリケーションを作成",
      titleIndex: "1.",
    },
    content: [
      {
        text: "<a class='is-static-link' href='/tutorial/oauth' target='_blank'>こちら</a>を参照してClient ID/Secretを取得してください。",
        type: ContentTypeEnum.link,
      },
    ],
  },
  {
    title: {
      level: TitleLevelEnum.third,
      text: "ユーザー認証",
      titleIndex: "2.",
    },
    content: [
      {
        text: "OAuth2.0認証を使ったアプリケーションをユーザーに利用してもらうには、ユーザー自身による認証手続きが必要となります。",
      },
      {
        text: "自社サービスの中に、Safieの認可用Webページに移動する仕組みをご用意ください。",
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.1",
        styleObject: { marginLeft: "24px" },
      },
      {
        text: "認可用Webページ上で、ユーザー（カメラ所有者）がSafieのIDとパスワードを入力して認証を許可すると、認可コードが発行されます。",
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.2",
        styleObject: { marginLeft: "24px" },
      },
      {
        image: {
          pcUrl: require("./images/img-01-pc.png"),
          spUrl: require("./images/img-01-sp.png"),
          pcWidth: "100%",
          pcMaxWidth: "904px",
          spWidth: "287px",
          spMaxWidth: "100%",
          title: "OAuth2.0認証のユーザー認証画面",
        },
        type: ContentTypeEnum.image,
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.3",
        styleObject: { marginLeft: "24px" },
      },
      {
        text: "許可されるとRedirect URIで指定した画面に遷移します。認可コードはRedirect URIへ遷移後のクエリパラメータに付与されます。「?code=」の後から「&status=」の前までの文字列が認証コードです。",
        indexType: ContentIndexTypeEnum.index,
        indexText: "2.4",
        styleObject: { marginLeft: "24px" },
      },
      {
        text: "認可用エンドポイントの詳細は<a class='is-static-link' href='reference/api#tag/Auth-v2/operation/get-v2-auth-authorize' target='_blank'>こちらのドキュメント</a>を参考にしてください",
        styleObject: { marginLeft: "48px" },
        type: ContentTypeEnum["tip-link"],
      },
    ],
  },
  {
    title: {
      level: TitleLevelEnum.third,
      titleIndex: "3.",
      text: "アクセストークンの取得",
    },
    content: [
      {
        text: 'ここまで取得したClient ID/Secret、認可コードを用いてアクセストークン取得APIを実行します。アクセストークン、アクセストークンの有効期限（ミリ秒）、リフレッシュトークンが取得できます。アクセストークンが取得された際のレスポンスの"expires_in"に記載の秒数が、有効期限となります。',
      },
      {
        text: "アクセストークン取得APIのリクエストとレスポンスの詳細は<a class='is-static-link' href='reference/api#tag/Auth-v2/operation/post-v2-auth-token' target='_blank'>こちらのドキュメント</a>を参考にしてください",
        type: ContentTypeEnum["tip-link"],
      },
    ],
  },
  {
    title: {
      level: TitleLevelEnum.third,
      titleIndex: "4.",
      text: "アクセストークンのリフレッシュ",
    },
    content: [
      {
        text: "リフレッシュトークンを利用して、アクセストークンのリフレッシュAPIを実行してください。アクセストークンを更新することができます。アクセストークンを更新し続けることで、毎回認可コードを取得する必要がなくなります。",
      },
      {
        text: "アクセストークンのリフレッシュAPIの詳細は<a class='is-static-link' href='reference/api#tag/Auth-v2/operation/post-v2-auth-refresh-token' target='_blank'>こちらのドキュメント</a>を参考にしてください",
        type: ContentTypeEnum["tip-link"],
      },
    ],
  },
  {
    title: {
      level: TitleLevelEnum.third,
      titleIndex: "5.",
      text: "デバイス一覧の取得",
    },
    content: [
      {
        text: "取得したアクセストークンを使ってアクセス可能なデバイス一覧を取得します。各種APIリクエストの際のクエリーパラメータとなるdevice_idの値は、こちらで取得できる値を入力ください。",
      },
      {
        text: "OAuth2.0認証を用いてアクセストークンをリフレッシュするサンプルコードは、<a class='is-static-link' href='https://github.com/SafieDev/safie-api-sample-code/tree/main/authorization-oauth2' target='_blank'>こちら</a>を参考にしてください",
        type: ContentTypeEnum["tip-link"],
      },
    ],
  },
  {
    title: {
      text: "静止画の取得・イベントフラグの作成を行う",
    },
  },
  {
    title: {
      text: "想定ケース",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "映像データから静止画を取得したい",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "自社の画像解析システムや外部センサーで検知したイベントのフラグを立てたい",
        indexType: ContentIndexTypeEnum.circle,
      },
    ],
  },
  {
    title: {
      text: "APIを利用して静止画取得とイベントフラグ生成を行うには？",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "デバイス（カメラ）から取得した静止画像データを解析してSafie Viewer上に独自のイベントフラグを立てる、という機能を開発します。",
      },
      {
        text: "Safie Viewerは標準機能として、デバイスが検知したサウンドやモーションのイベントを受け取り、タイムラインにフラグを立てます。そこで外部センサーの検知するイベントや、セーフィーには無い画像解析を用いて検知するイベントなどに応じて独自のフラグを立てたい場合は、以下のような手順の設計が考えられます。",
      },
      {
        type: ContentTypeEnum.image,
        image: {
          pcUrl: require("./images/img-02.png"),
          spUrl: require("./images/img-02.png"),
          pcWidth: "100%",
          pcMaxWidth: "960px",
          spWidth: "100%",
          spMaxWidth: "960px",
        },
      },
    ],
  },
  {
    title: {
      text: "サンプルコード",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "サンプルコードをご用意しました。<a class='is-static-link' href='https://github.com/SafieDev/safie-api-sample-code/tree/main/get-image-set-flag' target='_blank'>こちら</a>をご参考にしてください。※初めてSafie APIを利用する方向けです。APIキー認証方式のアプリケーションを想定しています。",
        type: ContentTypeEnum.link,
      },
      {
        text: "最終的なViewerの画面は以下の写真のようになります。赤色の外部イベント（external_event）が立っているのが分かります。",
      },
      {
        type: ContentTypeEnum.image,
        image: {
          pcUrl: require("./images/img-03.png"),
          spUrl: require("./images/img-03.png"),
          pcWidth: "100%",
          pcMaxWidth: "960px",
          spWidth: "100%",
          spMaxWidth: "960px",
          title: "Safie Viewer外部イベント作成",
        },
      },
    ],
  },
  {
    title: {
      text: "メディアファイルを作成する",
    },
  },
  {
    title: {
      text: "想定ケース",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "特定の時間の映像データを取得して保存しておきたい",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "特定の時間の映像データを取得して自社の解析システムで解析したい",
        indexType: ContentIndexTypeEnum.circle,
      },
    ],
  },
  {
    title: {
      text: "メディアファイルを作成するには？",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "デバイスが取得した映像データからメディアファイルを作成した後、ダウンロードするという機能を開発することを想定します。",
      },
      {
        text: "Safie Viewerのメディアファイルプランでは、デバイスで撮影された動画をメディアデータとしてダウンロードすることができます。APIを利用して、任意のメディアファイルの作成・作成状況確認・ダウンロード/削除を行うためには、以下のような設計が考えられます。",
      },
      {
        type: ContentTypeEnum.image,
        image: {
          pcUrl: require("./images/img-04.png"),
          spUrl: require("./images/img-04.png"),
          pcWidth: "100%",
          pcMaxWidth: "960px",
          spWidth: "100%",
          spMaxWidth: "960px",
          title: "メディアファイル作成",
        },
      },
    ],
  },
  {
    title: {
      text: "サンプルコード",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "サンプルコードをご用意しました。<a class='is-static-link' href='https://github.com/SafieDev/safie-api-sample-code/tree/main/mediafile-download' target='_blank'>こちら</a>をご参考にしてください。",
        indexType: ContentIndexTypeEnum.circle,
        type: ContentTypeEnum.link,
      },
      {
        text: "本ページに記載されるコードは、あくまで初めてSafie APIを使ってみる方向けの動作確認するためのコードになります。",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "初めてSafie APIを利用する方向けです。APIキー認証方式のアプリケーションを想定しています",
        type: ContentTypeEnum.tip,
        styleObject: { marginLeft: "24px" },
      },
    ],
  },
  {
    title: {
      text: "注意点",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "Safie ViewerのGUIを通して作られたムービークリップをダウンロードしたい場合は、ムービークリップのAPIを利用ください。",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "制約事項に関しては<a href='/terms-of-api' class='is-static-link' target='_blank'>こちら</a>をご参照ください。",
        indexType: ContentIndexTypeEnum.circle,
        type: ContentTypeEnum.link,
      },
    ],
  },
  {
    title: {
      text: "ライブストリーミング映像の取得を行う",
    },
  },
  {
    title: {
      text: "想定ケース",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "リアルタイムの動画を自社の解析システムで解析したい",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "ストリーミング映像を自社システムに組み込んで再配信したい（再配信部分は別途実装の必要あり）",
        indexType: ContentIndexTypeEnum.circle,
      },
    ],
  },
  {
    title: {
      text: "ライブストリーミング映像を取得するには？",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "デバイス（カメラ）からストリーミング映像のプレイリストを取得し、その映像を1分間隔で保存するという機能を開発することを想定します。ストリーミング映像は、HTTP Live Streamingのプレイリスト形式 (application/x-mpegURL) で取得できます。",
      },
      {
        type: ContentTypeEnum.image,
        image: {
          pcUrl: require("./images/img-05.png"),
          spUrl: require("./images/img-05.png"),
          pcWidth: "100%",
          pcMaxWidth: "960px",
          spWidth: "100%",
          spMaxWidth: "960px",
          title: "ストリーミングの再生",
        },
      },
    ],
  },
  {
    title: {
      text: "サンプルコード",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "サンプルコードをご用意しました。<a class='is-static-link' href='https://github.com/SafieDev/safie-api-sample-code/tree/main/streaming-download' target='_blank'>こちら</a>をご参考にしてください。",
        indexType: ContentIndexTypeEnum.circle,
        type: ContentTypeEnum.link,
      },
      {
        text: "初めてSafie APIを利用する方向けです。APIキー認証方式のアプリケーションを想定しています",
        type: ContentTypeEnum.tip,
      },
    ],
  },
  {
    title: {
      text: "注意点",
      level: TitleLevelEnum.second,
      hasBorder: true,
    },
    content: [
      {
        text: "配信サーバーはサーバーメンテナンス等の理由により不定期に入れ替わります。 継続的に映像配信を利用するには再接続等の実装が必要になります。",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "対象デバイスの録画設定がオフになっている、電源がオフになっているなど映像ストリーミングが行われていないとき400エラーとなります。",
        indexType: ContentIndexTypeEnum.circle,
      },
      {
        text: "1デバイスあたりのストリーミング数は、トライアルプランとプロダクトプランで1つずつとなります。",
        indexType: ContentIndexTypeEnum.circle,
      },
    ],
  },
];
const context: IStaticContext = {
  headerTitle: "設計ガイドライン",
  headerIcon: require("./images/header-icon.png"),
  data,
};
export default context;
